module.exports = __webpack_public_path__ + "static/media/cuba.fd266209.svg";